const filterLiveChartData = (chartData) => {
    if (!Array.isArray(chartData)) return chartData;
    const hasIsLiveFlag = chartData.some(item =>
        Object.prototype.hasOwnProperty.call(item || {}, "IsLive")
    );
    return hasIsLiveFlag
        ? chartData.filter(item => item?.IsLive === true)
        : chartData;
};

export const convertToApexChartsPlots = (priceTrendData, key=null) => {

    if(!priceTrendData) return null;
    priceTrendData = filterLiveChartData(priceTrendData);
    const uniqueDates = [];
    // Collect all unique dates
    priceTrendData.forEach(supplierData => {
        supplierData.Prices.forEach(priceEntry => {
            if (uniqueDates.includes(priceEntry.Date)) return; // Skip if date already exists
            uniqueDates.push(priceEntry.Date);
        });
    });

    // Convert uniqueDates Set to an array and sort it (optional)
    const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));

    // Map prices for each supplier
    const result = priceTrendData.map((supplierData, index) => {
        const pricesForSupplier = sortedDates.map(date => {
            const priceEntry = supplierData.Prices.find(p => p.Date === date);
            return priceEntry ? priceEntry.Price : null;
        });
        const pointMeta = sortedDates.map(date => {
            const priceEntry = supplierData.Prices.find(p => p.Date === date);
            return {
                count: priceEntry ? priceEntry.Count ?? null : null,
                min: priceEntry ? priceEntry.Min ?? null : null,
                max: priceEntry ? priceEntry.Max ?? null : null,
                passThrough: priceEntry ? priceEntry.PassThroughCostComponents ?? "" : "",
            };
        });

        return {
            name: supplierData.Supplier,
            supplierId: supplierData.EnerexSupplierIdentifier,
            type: "line", //"index==0?"line":"column",
            data: pricesForSupplier,
            pointMeta
        };
    });

// const sortedSeries = [...result].sort((a, b) => {
//   if (a.name < b.name) return -1;
//   if (a.name > b.name) return 1;
//   return 0;
// });
const sortedSeries = [...result].sort((a, b) => 
  a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
);
    const formattedDates = sortedDates.map(date => {
    if (!date) return "";
    if (key.includes("forwardCurve")) {
        // input “MM/DD/YY” → output “MM/YY”
        const [MM, , YY] = date.split('/');
        return `${MM}/${YY}`;
    }
    // default “MM/DD”
    return date.slice(0, 5);
    });

    return {categories: formattedDates, series: sortedSeries};
}

export const convertToApexChartsMinMaxPlots = (priceTrendData, key=null) => {

    if(!priceTrendData) return null;
    priceTrendData = filterLiveChartData(priceTrendData);
    
    // Import supplier name to ID mapping
    const { supplierNameToId } = require('../../const/supplierColorMapping');
    
    const uniqueDates = [];
    const minPriceSeriesData = [];
    const maxPriceSeriesData = [];
    const meanPriceSeriesData = [];
    const medianPriceSeriesData = [];
    const priceSeries = [];
    const SupplierName = priceTrendData[0]?.Prices?.[0]?.Supplier;
    
    // Try to get supplier ID from the data first, then fallback to name lookup
    const SupplierId = priceTrendData[0]?.EnerexSupplierIdentifier || 
                       supplierNameToId[SupplierName] || 
                       null;
    
    // Collect all unique dates
    priceTrendData.forEach(supplierData => {
        supplierData.Prices.forEach(priceEntry => {
            uniqueDates.push(priceEntry.Date);
        });
    });

    // Convert uniqueDates Set to an array and sort it (optional)
    const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));

    // Map min & max series
    sortedDates.forEach(date => {
        // Assumes only one supplier per day, or takes the first matching
        const entry = priceTrendData.find(s =>
          s.Prices.some(p => p.Date === date)
        );
        const priceEntry = entry?.Prices.find(p => p.Date === date);
        minPriceSeriesData.push(priceEntry?.MinPrice ?? null);
        maxPriceSeriesData.push(priceEntry?.MaxPrice ?? null);
        meanPriceSeriesData.push(priceEntry?.MeanPrice ?? null);
        medianPriceSeriesData.push(priceEntry?.MedianPrice ?? null);
        priceSeries.push(priceEntry?.Price ?? null);
      });

    const result = [];
    
    // Only add supplier series if SupplierName is defined and not null
    if (SupplierName != null && SupplierName !== undefined) {
        result.push({
            name: SupplierName,
            supplierId: SupplierId,
            type: 'line',
            data: priceSeries        
        });
    }
    
    // Add other series
    result.push(
        {
            name: 'Max Price',
            type: 'line',
            data: maxPriceSeriesData,
        },
        {
            name: 'Mean Price',
            type: 'line',
            data: meanPriceSeriesData,
        },
        {
            name: 'Median Price',
            type: 'line',
            data: medianPriceSeriesData,
        },
        {
            name: 'Min Price',
            type: 'line',
            data: minPriceSeriesData,
        }
    );

    const formattedDates = sortedDates.map(date => {
    if (!date) return "";
    if (key.includes("forwardCurve")) {
        // input "MM/DD/YY" → output "MM/YY"
        const [MM, , YY] = date.split('/');
        return `${MM}/${YY}`;
    }
    // default "MM/DD"
    return date.slice(0, 5);
    });

    return {categories: formattedDates, series: result};
}
